import React from 'react'
import "./LHSRowContent.css"

function LHSRowContent() {
  return (
    <div style={{background:"black"}}>
    <div className='LHSRowContent-container standard-padding-space left-gradient-upper' >
        <div className='container '>
            <div className='row'>
                <div className='col-lg-4 text-center'>
                    <h4 className='body-heading color-light'>3 hrs</h4>
                    <p className='body-paragraph color-light'>Course length</p>
                </div>
                <div className='col-lg-4 text-center'>
                    <h3 className='body-heading color-light'>50+</h3>
                    <p className='body-paragraph color-light'>Actionable staging tips</p>
                </div>
                <div className='col-lg-4 text-center'>
                    <h4 className='body-heading color-light'>Since 2010</h4>
                    <p className='body-paragraph color-light'>Trusted across North America</p>
                </div>

            </div>
        </div>
    </div>
</div>
  )
}

export default LHSRowContent